export enum ViewImage {
  // common
  CommonHelpBannerBg = '/assets/common/helpBannerBg/desktop.jpg',
  CommonHelpBannerMobileBg = '/assets/common/helpBannerBg/mobile.jpg',
  CommonLogoLight = '/assets/common/logos/light.svg',
  CommonLogoDark = '/assets/common/logos/dark.svg',
  // common - file tiles
  PdfTile = '/assets/common/fileTypes/pdfTile.svg',
  DocTile = '/assets/common/fileTypes/docTile.svg',
  JpgTile = '/assets/common/fileTypes/jpgTile.svg',
  XlsTile = '/assets/common/fileTypes/xlsTile.svg',
  XmlTile = '/assets/common/fileTypes/xmlTile.svg',
  PptTile = '/assets/common/fileTypes/pptTile.svg',
  PngTile = '/assets/common/fileTypes/pngTile.svg',
  XadesTile = '/assets/common/fileTypes/xadesTile.svg',
  File = '/assets/common/fileTypes/file.svg',
  // common - file covers
  PdfCover = '/assets/common/fileTypes/pdfCover.svg',
  DocCover = '/assets/common/fileTypes/docCover.svg',
  JpgCover = '/assets/common/fileTypes/jpgCover.svg',
  XlsCover = '/assets/common/fileTypes/xlsCover.svg',
  PptCover = '/assets/common/fileTypes/pptCover.svg',
  PngCover = '/assets/common/fileTypes/pngCover.svg',
  // img
  SearchPopupNewsDefaultImage = '/assets/img/searchPopupNewsDefaultCover.png',
  TrainingsDefaultThumbnail = '/assets/img/defaultThumbnail.png',
  // test and forms
  TestAndFormsBottomShape = '/assets/views/testsAndForms/bottomShape.svg',
  TestAndFormsBottomShapeMobile = '/assets/views/testsAndForms/bottomShape.mobile.svg',
  TestAndFormsShape = '/assets/views/testsAndForms/shape.svg',
  TestAndFormsCarIcon = '/assets/views/testsAndForms/carIcon.svg',
  TestAndFormsKeyboard = '/assets/views/testsAndForms/keyboardIcon.svg',
  TestAndFormsMainBg = '/assets/views/testsAndForms/car.desktop.jpg',
  TestAndFormsMainBgMobile = '/assets/views/testsAndForms/car.mobile.jpg',
  // users administration - companiesList
  BannerImage = '/assets/views/usersAdministration/companiesList/banner.png',
  BottomShape = '/assets/views/usersAdministration/companiesList/bottomShape.svg',
  // users administration - user details
  UserDetailsMobileBackground = '/assets/views/usersAdministration/userDetails/mobileBg.png',
  UserDetailsBackgroundShape = '/assets/views/usersAdministration/userDetails/bgShape.svg',
  // users administration - courses
  AdministrationCoursesBannerDesktop = '/assets/views/usersAdministration/courses/bannerDesktop.png',
  AdministrationCoursesBannerMobile = '/assets/views/usersAdministration/courses/bannerMobile.png',
  AdministrationCoursesBottomShape = '/assets/views/usersAdministration/courses/bottomShape.svg',
  // users administration - company dashboard
  CompanyDashboardBarShapeMobile = '/assets/views/usersAdministration/companyDashboard/shapeMobile.svg',
  CompanyDashboardBarShape = '/assets/views/usersAdministration/companyDashboard/shape.svg',
  CompanyDashboardBottomShape = '/assets/views/usersAdministration/companyDashboard/bottomShape.svg',
  CompanyDashboardBottomShapeMobile = '/assets/views/usersAdministration/companyDashboard/bottomShapeMobile.svg',
  CompanyDashboardPopupShape = '/assets/views/usersAdministration/companyDashboard/popupShape.svg',
  CompanyDashboardPopupShapeMobile = '/assets/views/usersAdministration/companyDashboard/popupShapeMobile.svg',
  // users administration - cyclical lessons
  CyclicalLessonsBottomShape = '/assets/views/usersAdministration/cyclicalLessons/bottomShape.svg',
  CyclicalLessonsBannerDesktop = '/assets/views/usersAdministration/cyclicalLessons/bannerDesktop.png',
  CyclicalLessonsBannerMobile = '/assets/views/usersAdministration/cyclicalLessons/bannerMobile.png',
  // users administration - dashboard
  AdministrationDashboardCar = '/assets/views/usersAdministration/dashboard/car.png',
  AdministrationDashboardShapeMobile = '/assets/views/usersAdministration/dashboard/shapeMobile.svg',
  AdministrationDashboardShape = '/assets/views/usersAdministration/dashboard/shape.svg',
  AdministrationDashboardBottomShape = '/assets/views/usersAdministration/dashboard/bottomShape.svg',
  AdministrationDashboardBottomShapeMobile = '/assets/views/usersAdministration/dashboard/bottomShapeMobile.svg',
  // actionRequiredToAccessPlatform
  ActionRequiredToAccessPlatformDefaultBg = '/assets/views/actionRequiredToAccessPlatform/bg.jpg',
  // dashboard
  DashboardEventCardBackground = '/assets/views/dashboard/eventCardDefault.png',
  // anon survey
  AnonSurvey01 = '/assets/views/anonSurveys/01.jpg',
  AnonSurvey01Mobile = '/assets/views/anonSurveys/01_mobile.jpg',
  AnonSurvey02 = '/assets/views/anonSurveys/02.jpg',
  AnonSurvey02Mobile = '/assets/views/anonSurveys/02_mobile.jpg',
  AnonSurvey03 = '/assets/views/anonSurveys/03.jpg',
  AnonSurvey03Mobile = '/assets/views/anonSurveys/03_mobile.jpg',
  AnonSurvey04 = '/assets/views/anonSurveys/04.jpg',
  AnonSurvey04Mobile = '/assets/views/anonSurveys/04_mobile.jpg',
  AnonSurvey05 = '/assets/views/anonSurveys/05.jpg',
  AnonSurvey05Mobile = '/assets/views/anonSurveys/05_mobile.jpg',
  AnonSurvey06 = '/assets/views/anonSurveys/06.jpg',
  AnonSurvey06Mobile = '/assets/views/anonSurveys/06_mobile.jpg',
  AnonSurvey07 = '/assets/views/anonSurveys/07.jpg',
  AnonSurvey07Mobile = '/assets/views/anonSurveys/07_mobile.jpg',
  AnonSurvey08 = '/assets/views/anonSurveys/08.jpg',
  AnonSurvey08Mobile = '/assets/views/anonSurveys/08_mobile.jpg',
  AnonSurvey09 = '/assets/views/anonSurveys/09.jpg',
  AnonSurvey09Mobile = '/assets/views/anonSurveys/09_mobile.jpg',
  AnonSurvey10 = '/assets/views/anonSurveys/10.jpg',
  AnonSurvey10Mobile = '/assets/views/anonSurveys/10_mobile.jpg',
  AnonSurvey11 = '/assets/views/anonSurveys/11.jpg',
  AnonSurvey11Mobile = '/assets/views/anonSurveys/11_mobile.jpg',
  AnonSurvey12 = '/assets/views/anonSurveys/12.jpg',
  AnonSurvey12Mobile = '/assets/views/anonSurveys/12_mobile.jpg',
  AnonSurvey13 = '/assets/views/anonSurveys/13.jpg',
  AnonSurvey13Mobile = '/assets/views/anonSurveys/13_mobile.jpg',
  AnonSurvey14 = '/assets/views/anonSurveys/14.jpg',
  AnonSurvey14Mobile = '/assets/views/anonSurveys/14_mobile.jpg',
  AnonSurvey15 = '/assets/views/anonSurveys/15.jpg',
  AnonSurvey15Mobile = '/assets/views/anonSurveys/15_mobile.jpg',
  AnonSurvey16 = '/assets/views/anonSurveys/16.jpg',
  AnonSurvey16Mobile = '/assets/views/anonSurveys/16_mobile.jpg',
  // substitutions
  SubstitutionCreateBgDesktop = '/assets/views/substitutions/bgDesktop.jpg',
  SubstitutionCreateBgMobile = '/assets/views/substitutions/bgMobile.jpg',
  // substitutions - dashboard
  SubstitutionsDashboardBannerDesktop = '/assets/views/substitutions/dashboard/bannerDesktop.jpg',
  SubstitutionsDashboardBannerMobile = '/assets/views/substitutions/dashboard/bannerMobile.jpg',
  SubstitutionsDashboardBars = '/assets/views/substitutions/dashboard/bars.svg',
  SubstitutionsDashboardRays = '/assets/views/substitutions/dashboard/rays.svg',
    // substitutions - list
  SubstitutionsListBannerDesktop = '/assets/views/substitutions/list/bannerDesktop.png',
  SubstitutionsListBannerMobile = '/assets/views/substitutions/list/bannerMobile.png',
  SubstitutionsListFrame = '/assets/views/substitutions/list/frame.svg',
  // userProfile
  UserProfileAvatarPopupRedShape = '/assets/views/userProfile/avatarPopupRedShape.svg',
  UserProfileAvatarPopupGrayShape = '/assets/views/userProfile/avatarPopupGrayShape.svg',
  // legal forms
  LegalFormBg = '/assets/views/legalForm/bg.jpg',
  LegalFormMobileBg = '/assets/views/legalForm/mobileBg.jpg',
  LegalFormCar = '/assets/views/legalForm/car.png',
  LegalFormDocumentsIcon = '/assets/views/legalForm/documents.svg',
  LegalFormHeaderImage = '/assets/views/legalForm/headerImage.svg',
  LegalFormHeaderMobileImage = '/assets/views/legalForm/headerMobileImage.svg',
  LegalFormsPassportExample = '/assets/views/legalForm/passportExample.jpg'
}
